import script from "./getPrivateKey.vue?vue&type=script&lang=ts&setup=true"
export * from "./getPrivateKey.vue?vue&type=script&lang=ts&setup=true"

import "./getPrivateKey.vue?vue&type=style&index=0&id=def1eef0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-def1eef0"]])

export default __exports__